import {z} from "zod/v4-mini"

export const texNoiseDimensionsSchema = z.enum(["1D", "2D", "3D", "4D"])
export type TexNoiseDimensions = z.infer<typeof texNoiseDimensionsSchema>

export const texNoiseTypeSchema = z.enum(["MULTIFRACTAL", "RIDGED_MULTIFRACTAL", "HYBRID_MULTIFRACTAL", "FBM", "HETERO_TERRAIN"])
export type TexNoiseType = z.infer<typeof texNoiseTypeSchema>
